import styled from 'styled-components';

export const Container = styled.div``;

export const ContainerPagination = styled.div`
  max-height: 320px;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 1rem 0 0;
`;

